import _ from 'lodash'

import {
  State,
  RegionInfo,
  ProviderRegion,
  ProviderRegionState,
  ProviderInfo,
  Regions,
} from 'js/types'
import {getSortedResources, SortTypes} from 'js/utils/sort'

export const getRegionInfo = ({providerRegion}: State): RegionInfo => {
  return providerRegion.regionInfo
}

export const getProviderInfo = ({providerRegion}: State): ProviderInfo =>
  providerRegion.providerInfo

export const allRegions = ({providerRegion}: State): Regions =>
  providerRegion.allProviderRegions.regionInfo

export const getRegions = (state: State): RegionInfo[] => {
  const {provider} = getProviderInfo(state)
  const regions = allRegions(state)

  return regions[provider]
}

const sortRegions = (regions: RegionInfo[]): RegionInfo[] => {
  return getSortedResources(regions, 'priority', 'asc', SortTypes.Float)
}

export const setupProviderRegionInitialState = (
  providerRegion: ProviderRegion
): ProviderRegionState => {
  const sortedProviders = getSortedResources(
    providerRegion.providerInfo,
    'title',
    'asc',
    SortTypes.String
  )
  const providerInfo = sortedProviders[0]
  const sortedRegions = Object.entries(providerRegion.regionInfo).reduce(
    (acc, [providerKey, regionInfos]) => {
      acc[providerKey] = sortRegions(regionInfos)
      return acc
    },
    {}
  )
  const regionInfo = sortedRegions[providerInfo.provider][0]
  return {
    allProviderRegions: {
      providerInfo: sortedProviders,
      regionInfo: sortedRegions,
    },
    providerInfo,
    regionInfo,
  }
}
